const initialState = {
  isVisible: false,
  title: '',
  content: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'DISPLAY_POPUP':
      return {
        ...state,
        isVisible: action.payload,
      };
    case 'HIDE_POPUP':
      return initialState;
    case 'FETCH_CONTENT_SUCCESS':
      return {
        ...state,
        content: action.payload,
      };
    case 'FETCH_TITLE':
      return {
        ...state,
        title: action.payload,
      };
    default:
      return state;
  }
}
